module.exports = __webpack_public_path__ + "img/152.1b712398.jpg";